/*eslint-disable*/
import { useState, useEffect } from "react";
import classNames from "classnames";
import { NavLink, useLocation } from "react-router-dom";

// @material-ui/core components
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";

// core components
import AdminNavbarLinks from "../Navbars/AdminNavbarLinks.js";
import RTLNavbarLinks from "../Navbars/RTLNavbarLinks.js";

// Styles
import sidebarStyle from "../../layout/material-dashboard-react/components/sidebarStyle";
import { CSSObject, styled, useTheme, Theme } from '@mui/material/styles';

import MuiDrawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { SidebarProps } from "./types.js";

const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(5)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

export default function Sidebar(props: SidebarProps) {
    const { color, logo, image, routes } = props;

    const [open, setOpen] = useState(true);

    const classes = sidebarStyle();
    const location = useLocation();
    const theme = useTheme();

    // verifies if routeName is the one active (in browser input)
    const isActiveRoute = (routeName) => location.pathname === routeName;

    const toggleDrawer = (drawerIsOpen) => setOpen(drawerIsOpen);

    const links = (
        <List className={classes.list}>
            {routes.map((prop, key) => {
                const routeName = prop.layout + prop.path;

                const listItemClasses = classNames({
                    [" " +  classes[color]]: isActiveRoute(routeName),
                });
                const whiteFontClasses = classNames({
                    [" " + classes.whiteFont]: isActiveRoute(routeName),
                });

                if (prop.active != "hidden") {
                    const propNameNoSpacesTestID = "sidebarNav" + prop.name.replace(/ /g,'');
                    return (
                        <NavLink
                            to={prop.layout + prop.path}
                            className={classes.item}
                            activeClassName="active"
                            key={key}
                            style={{ visibility: prop.active }}
                        >
                            <ListItem button className={classes.itemLink + listItemClasses} data-testid={propNameNoSpacesTestID}>
                                {typeof prop.icon === "string" ? (
                                    <Icon
                                        className={classNames(classes.itemIcon, whiteFontClasses, {
                                            [classes.itemIconRTL]: props.rtlActive,
                                        })}
                                    >
                                        {prop.icon}
                                    </Icon>
                                ) : (
                                    <prop.icon
                                        className={classNames(classes.itemIcon, whiteFontClasses, {
                                            [classes.itemIconRTL]: props.rtlActive,
                                        })}
                                        style={{ backgroundColor: prop.iconbackground !== "" ? prop.iconbackground : "#ee2e24", borderRadius: '2px', padding: '3px' }}
                                    />
                                )}
                                <ListItemText
                                    primary={props.rtlActive ? prop.rtlName : prop.name}
                                    className={classNames(classes.itemText, whiteFontClasses, {
                                        [classes.itemTextRTL]: props.rtlActive,
                                    })}
                                    disableTypography={true}
                                />
                                
                            </ListItem>
                        </NavLink>
                    );
                }
            })}
        </List>
    );
    const visibleRoutes = routes.filter(route => route.active !== 'hidden');
    const iconLinks = (
        <List className={classes.list}>
            {visibleRoutes.map((prop, key) => {
                const listItemClasses = classNames({
                    [" " + classes[color]]: isActiveRoute(prop.layout + prop.path),
                });

                const whiteFontClasses = classNames({
                    [" " + classes.whiteFont]: isActiveRoute(prop.layout + prop.path),
                });

                return (
                    <NavLink
                        to={prop.layout + prop.path}
                        className={classes.item}
                        activeClassName="active"
                        key={key}
                        style={{ visibility: prop.active }}
                    >
                        <ListItem button className={classes.itemLink + listItemClasses} style={{ width: '40px', height: '40px' }}>
                            {typeof prop.icon === "string" ? (
                                <Icon
                                    className={classNames(classes.itemIcon, whiteFontClasses, {
                                        [classes.itemIconRTL]: props.rtlActive,
                                    })}
                                >
                                    {prop.icon}
                                </Icon>
                            ) : (
                                <prop.icon
                                    className={classNames(classes.itemIcon, whiteFontClasses, {
                                        [classes.itemIconRTL]: props.rtlActive,
                                    })}
                                    style={{ backgroundColor: prop.iconbackground !== "" ? prop.iconbackground : "#ee2e24", borderRadius: '2px', height: '40px', width: '40px', marginLeft: '-15px', marginTop: '-10px' }}
                                />
                            )}
                        </ListItem>
                    </NavLink>
                );
            })}

        </List>
    );

    return (
         <div>
            <Hidden mdUp implementation="css">
                <Drawer
                    variant="temporary"
                    anchor={props.rtlActive ? "left" : "right"}
                    open={props.open}
                    classes={{
                    paper: classNames(classes.drawerPaper, {
                        [classes.drawerPaperRTL]: props.rtlActive,
                    }),
                    }}
                        onClose={props.handleDrawerToggle}
                        ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                >
                    {/* {brand} */}
                    <div className={classes.sidebarWrapper}>
                        {props.rtlActive ? <RTLNavbarLinks /> : <AdminNavbarLinks />}
                        {links}
                    </div>
                    {image !== undefined ? (
                        <div
                            className={classes.background}
                            style={{ backgroundImage: "url(" + image + ")" }}
                        />
                     ) : null}
                </Drawer>
            </Hidden>
            <Hidden smDown implementation="css">
                <Drawer
                    anchor={props.rtlActive ? "right" : "left"}
                    variant="permanent"
                    open={open}
                            sx={{ display: 'flex' }}
                        >
                    {open && (
                        <div className={classes.logo}>
                            <a
                                href={process.env.REACT_APP_PUBLIC_URL}
                                className={classNames(classes.logoLink, {
                                    [classes.logoLinkRTL]: props.rtlActive,
                                })}
                                style={{ height: '0px !important' }}
                                target="_blank"
                            >
                                <div className={classes.logoImage}>
                                    <img src={logo} alt="logo" className={classes.img}  />
                                </div>
                            </a>
                        </div>
                    )}
                    {!open && (<div className={classes.sidebarWrapper}>{iconLinks}
                        {!open && (<IconButton onClick={() => toggleDrawer(true)} style={{ backgroundColor: '#FFF', marginLeft: '10px', bottom: '2%', position: 'fixed' }}>
                            {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton>)}
                    </div>)}
                    {open && (<div className={classes.sidebarWrapper}>{links}
                        {open && (<IconButton onClick={() => toggleDrawer(false)} style={{ backgroundColor: '#FFF', marginLeft: '178px', bottom: '2%', position: 'fixed' }}>
                        {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />} 
                        </IconButton>)}
                    </div>)}
                    {image !== undefined ? (
                    <div
                        className={classes.background}
                        style={{ backgroundImage: "url(" + image + ")" }}
                    />
                        ) : null}
                </Drawer>
            </Hidden>
        </div>
    );
}
